import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { addMediaShare, fetchAdminHistoryChatView, fetchAdminToStaffChatList, fetchChatHistoryList, fetchParentViaStaffChatView, fetchStaffToParentChatList, fetchStaffToStaffChatList, fetchStffListChatView } from "../../../service/api";


export const getStaffToStaffChat = createAsyncThunk(
    "chats/getChats",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffToStaffChatList(params)
            console.log("chat list", response)
            return response.data.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const uploadMediaShare = createAsyncThunk(
    "chats/uploadMedia",
    async (params, { rejectWithValue }) => {
        try {
            const response = await addMediaShare(params)
            return response.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)





export const getAdminToStaffChatList = createAsyncThunk(
    "chats/getAdminChats",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAdminToStaffChatList(params)
            console.log("adminside staff list", response)
            return response.data.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getStaffToParentChat = createAsyncThunk(
    "chats/getParentChats",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffToParentChatList(params)
            console.log("parent  list", response)
            return response.data.data
        } catch (error) {
            console.log("parent list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



export const getChatHistory = createAsyncThunk(
    "chats/getHistory",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChatHistoryList(params)
            console.log("chat history", response)
            return response.data.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getStffListChatView = createAsyncThunk(
    "chats/getAdminStaffView",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStffListChatView(params)
            console.log("admin view staff list ", response)
            return response.data.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getAdminHistoryChatView = createAsyncThunk(
    "chats/getAdminViewHistory",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAdminHistoryChatView(params)
            console.log("admin view staff list ++++ ", response)
            return response.data.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getParentViaStaffChatView = createAsyncThunk(
    "chats/getAdminParentViaStaff",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchParentViaStaffChatView(params)
            console.log("admin staff vis parent  ", response)
            return response.data.data
        } catch (error) {
            console.log("chat list err", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


const MessasingSlice = createSlice({
    name: "chats",
    initialState: {
        chatList: [],
        adminStaffList: [],
        parentList: [],
        chatHostory: [],
        adminViewHistory: [],
        adminStaffView: [],
        adminParentView: [],
        isLoading: false,
        isMsgLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 1,
        msgTotal: 1,
        current: 1,
        msgcurrent: 1,
        limit: 10,
        userId: "",
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setMsgPagination: (state, action) => {
            state.msgcurrent = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setNewChat: (state, action) => {
            state.chatHostory.push(action.payload);
        },
        setUserId: (state, action) => {
            state.userId = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getStaffToStaffChat.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getStaffToStaffChat.fulfilled, (state, action) => {
                state.isLoading = false

                const page = action.meta.arg.currentPage;

                if (page === 1) {
                    state.chatList = action.payload.data;
                } else {
                    state.chatList = [
                        ...state.chatList,
                        ...action.payload.data,
                    ];
                }

                state.totalPage = action.payload.totalPage;
            })
            .addCase(getStaffToStaffChat.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            .addCase(getAdminToStaffChatList.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAdminToStaffChatList.fulfilled, (state, action) => {
                state.isLoading = false

                const page = action.meta.arg.currentPage;

                if (page === 1) {
                    state.adminStaffList = action.payload.data;
                } else {
                    state.adminStaffList = [
                        ...state.adminStaffList,
                        ...action.payload.data,
                    ];
                }

                state.totalPage = action.payload.totalPage;
            })
            .addCase(getAdminToStaffChatList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })
            // Parent
            .addCase(getStaffToParentChat.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getStaffToParentChat.fulfilled, (state, action) => {
                state.isLoading = false;

                const page = action.meta.arg.currentPage;

                if (page === 1) {
                    state.parentList = action.payload.data;
                } else {
                    state.parentList = [
                        ...state.parentList,
                        ...action.payload.data,
                    ];
                }
                state.totalPage = action.payload.totalPage;
            })
            .addCase(getStaffToParentChat.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // GET HOSTORY
            .addCase(getChatHistory.pending, (state) => {
                state.isMsgLoading = true,
                    state.error = null
            })
            .addCase(getChatHistory.fulfilled, (state, action) => {
                state.isMsgLoading = false;
                const page = action.meta.arg.currentPage;
                if (page === 1) {
                    state.chatHostory = action.payload.data;
                } else {
                    state.chatHostory = [
                        ...action.payload.data,
                        ...state.chatHostory,
                    ];
                }
                state.current = action.meta.arg.currentPage
                state.msgTotal = action.payload.totalPage;
            })

            .addCase(getChatHistory.rejected, (state, action) => {
                state.isMsgLoading = false;
                state.error = action.payload
            })

            // admin staff list view
            .addCase(getStffListChatView.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getStffListChatView.fulfilled, (state, action) => {
                state.isLoading = false;
                const page = action.meta.arg.currentPage;

                if (page === 1) {
                    state.adminStaffView = action.payload.data;
                } else {
                    state.adminStaffView = [
                        ...state.adminStaffView,
                        ...action.payload.data,
                    ];
                }
                state.totalPage = action.payload.totalPage;

            })
            .addCase(getStffListChatView.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // admin history view
            .addCase(getAdminHistoryChatView.pending, (state) => {
                state.isMsgLoading = true,
                    state.error = null
            })
            .addCase(getAdminHistoryChatView.fulfilled, (state, action) => {
                state.isMsgLoading = false;
                const page = action.meta.arg.currentPage;
                if (page === 1) {
                    state.adminViewHistory = action.payload.data;
                } else {
                    state.adminViewHistory = [
                        ...action.payload.data,
                        ...state.adminViewHistory,
                    ];
                }
                state.msgcurrent = action.meta.arg.currentPage
                state.msgTotal = action.payload.totalPage;

            })
            .addCase(getAdminHistoryChatView.rejected, (state, action) => {
                state.isMsgLoading = false;
                state.error = action.payload
            })

            // admin parent via staff view
            .addCase(getParentViaStaffChatView.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getParentViaStaffChatView.fulfilled, (state, action) => {
                state.isLoading = false;
                const page = action.meta.arg.currentPage;

                if (page === 1) {
                    state.adminParentView = action.payload.data;
                } else {
                    state.adminParentView = [
                        ...state.adminParentView,
                        ...action.payload.data,
                    ];
                }
                state.totalPage = action.payload.totalPage;

            })
            .addCase(getParentViaStaffChatView.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })
            // MEDIA POST
            .addCase(uploadMediaShare.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(uploadMediaShare.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(uploadMediaShare.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })
    }
})
export const { setSearchParams, setPagination, setNewChat, setUserId, setMsgPagination } = MessasingSlice.actions;

export default MessasingSlice.reducer;